import { FC } from 'react';
import { useSelector } from 'react-redux';

import { BookingInfo } from 'src/api/bookingsView';
import { Grid } from 'src/components/Grid/Grid';
import { getDeviceSize, getIsDesktop } from 'src/store/agent/selectors';
import { getSearchState } from 'src/store/search/selectors';
import { DeviceSize } from 'src/types';

import { BookingCard } from './BookingCard/BookingCard';
import { desktopBookingCardHeight } from './BookingCard/DesktopBookingCard/consts';
import { mobileBookingCardHeight } from './BookingCard/MobileBookingCard/consts';
import { useSearch } from './SearchProvider';

const twoColumnsSizes = new Set([DeviceSize.XL, DeviceSize.L, DeviceSize.M]);

const Item: FC<{ data: BookingInfo }> = ({ data }) => {
  return <BookingCard booking={data} />;
};

export const SearchList: FC = () => {
  const isDesktop = useSelector(getIsDesktop);
  const size = useSelector(getDeviceSize);
  const { loadMore } = useSearch();

  const { rows, loading } = useSelector(getSearchState);

  const bookingCardHeight = isDesktop
    ? desktopBookingCardHeight
    : mobileBookingCardHeight;

  return (
    <Grid<BookingInfo>
      columnCount={twoColumnsSizes.has(size) ? 2 : 1}
      rows={rows}
      loadMore={loadMore}
      rowHeight={bookingCardHeight}
      Item={Item}
      noResults='Бронирования не найдены'
      isLoading={loading}
      loading='Загрузка бронирований'
    />
  );
};
